import { render, staticRenderFns } from "./gradePedidos.vue?vue&type=template&id=3eb15780&"
import script from "./gradePedidos.vue?vue&type=script&lang=js&"
export * from "./gradePedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports